export const BACKEND_URL =
  import.meta.env.VITE_BACKEND_URL || "https://dev.api.headstart.health";
export const WEBSITE_URL =
  import.meta.env.VITE_WEBSITE_URL || "https://dev.headstart.health";
export const BOTPRESS_CLIENT_ID = import.meta.env.VITE_BOTPRESS_CLIENT_ID || "";
